import { ErrorBoundary } from 'react-error-boundary';
import { Redirect, Switch, useLocation, useRouteMatch } from 'react-router-dom';
import Content from 'assets/js/components/Content';
import { ErrorSplash } from 'assets/js/pages/ErrorSplash';
import { DataHygieneDuplicates } from 'assets/js/pages/contacts/duplicates/DataHygieneDuplicates';
import { Route } from 'components/router/Route';
import * as SubNav from 'components/sub-nav';
import { ContactsSubNavTabs } from 'components/sub-nav/ContactsSubNavTabs';

const Duplicates = () => {
    const match = useRouteMatch();
    const location = useLocation();

    return (
        <div className={'grid grid-cols-10 gap-4'}>
            <div className={'col-span-full'}>
                <ErrorBoundary resetKeys={[location.pathname]} fallbackRender={ErrorSplash}>
                    <Switch>
                        <Route
                            exact={true}
                            path={`${match.path}`}
                            component={DataHygieneDuplicates}
                        />
                        <Route>
                            <Redirect to={match.url} />
                        </Route>
                    </Switch>
                </ErrorBoundary>
            </div>
        </div>
    );
};

const DuplicatesRouter = () => {
    return (
        <Content className="flex flex-col gap-y-4">
            <SubNav.Root>
                <SubNav.Header>
                    <SubNav.Title>Contacts</SubNav.Title>
                </SubNav.Header>
                <ContactsSubNavTabs />
            </SubNav.Root>

            <Duplicates />
        </Content>
    );
};

export { Duplicates, DuplicatesRouter };
